import React from "react";

const varun_kudtarkar = () => {
  return (
    <div>
      <h1>Varun Kudtarkar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There was no CGPA criteria, but only CS, ENTC and Robotics and AI
        students were allowed to participate.{" "}
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        Firstly there was a google form to register, where we also had to choose
        which role we wanted to apply for. There were three roles: Python - QA,
        Python - Dev Ex, C++. An online test was taken where questions were
        asked based on the chosen role. Then lastly the interview round was
        held.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round consisted of 10 MCQs and 2 coding questions. Around 1
        hr was the time frame given. Both coding questions were simple array
        manipulation problems. The questions had to be solved in the programming
        language of the given role. The MCQs were different based on different
        roles.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        After the aptitude round around 40 students were chosen. 20 for C++, 11
        for QA and 8 for Dev Ex.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The interviews were held after 1 week. During this time I prepared my
        chosen role which was Python - QA. The pytest library and unitest
        library are the fundamentals of testing in python. Some theory knowledge
        regarding testing in general are also important like types of testing.
        Also core python and deep knowledge about different features of python
        is essential.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        For the QA role on the day of the interview, a pen and paper test was
        taken. The test had the same format as the aptitude round, but this time
        all the questions were related to python and its features. The coding
        questions were meant to be solved by writing the code on paper. Out of
        11 only 4 were selected after the test. Then the interview was taken on
        the same day. The HR round was taken 2-3 days later which was online.
        Out 4 only 2 were selected for HR. After HR both of us were selected for
        the internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The main topics which the interviewer focused on were python, SQL and
        testing in python. You should really be confident in your python skills
        since advanced questions related to python may be asked. Questions about
        SQL were also asked along with finding queries for a given problem.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Geeks for Geeks is a really good website to prepare interview questions
        for different topics. For coding questions, leetcode can be helpful to
        practice.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Choose a language with which you are comfortable and stick to it. Solve
        a lot of problems till you are able to visualise the solution quickly.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Only basic questions about projects were asked. They mainly focused on
        the above mentioned topics.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        This company heavily asks about the role chosen, so thoroughly preparing
        only about the role is enough.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The internship can feel overwhelming as it is the first time we
        experienced something like this, but if you have worked hard and are
        confident in your abilities there is nothing to be worried about.
      </p>
    </div>
  );
};

export default varun_kudtarkar;
